export default () => {
  (function () {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;
    let launchDate = '01/01/2022';
    const countDown = new Date(launchDate).getTime();
    setInterval(function() {
      const now = new Date().getTime();
      const distance = countDown - now;
      const days = document.getElementById('days');
      if(days) days.innerText = Math.floor(distance / (day));
      
      const hours = document.getElementById('hours');
      if(hours) hours.innerText = Math.floor((distance % (day)) / (hour));

      const minutes = document.getElementById('minutes');
      if(minutes) minutes.innerText = Math.floor((distance % (hour)) / (minute));

      const seconds = document.getElementById('seconds');
      if(seconds) seconds.innerText = Math.floor((distance % (minute)) / second);;
    }, 0);
  }());
};